module.exports = __webpack_public_path__ + "img/information-icon-black.24a4c805.svg";